import {rpAppLink} from "@pg-mono/rp-routes";

import {OfferType} from "../../offer/types/OfferType";

export const offerTypeUrl = (offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return rpAppLink.siteMap.flat();
        case OfferType.COMMERCIAL:
            return rpAppLink.siteMap.commercial();
        case OfferType.HOUSE:
            return rpAppLink.siteMap.house();
        default:
            return rpAppLink.siteMap.flat();
    }
};
import {rpAppLink} from "@pg-mono/rp-routes";

import {OfferType} from "../../offer/types/OfferType";

export const offerTypeUrl = (offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return rpAppLink.siteMap.flat();
        case OfferType.COMMERCIAL:
            return rpAppLink.siteMap.commercial();
        case OfferType.HOUSE:
            return rpAppLink.siteMap.house();
        default:
            return rpAppLink.siteMap.flat();
    }
};
